import { Dialog } from '@/components/UI/Dialog'
import { HtmlContent } from '@/components/UI/HtmlContent'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  onClose: () => void
  /** storybookで確認する際に、スクロール可にするためのフラグ。raundで利用する場合にはtrue */
  scrollLock?: boolean
  /** 管理画面で登録したクイズタイトル。未指定時は i18n フォールバック「クイズ」を使用 */
  title?: string | null
  /** クイズの問題文 */
  question: string
  /** クイズ画像URL */
  image?: string | null
  /** 選択肢リスト */
  choices: { id: number; item: string | null }[]
  /** 選択肢を選んだときのコールバック（選択肢IDを返す） */
  onSelect: (choiceId: number) => void
  /** API呼び出し中フラグ（trueのとき選択肢を無効化） */
  isLoading?: boolean
}

/**
 * `Raund-Replace / Screen UI / SPOT-DETAIL-スタンプ獲得（クイズ）`のダイアログコンポーネント
 * Figma node: 439:7852
 */
export const DialogQuizChallenge = memo(
  ({ onClose, scrollLock = false, title, question, image, choices, onSelect, isLoading = false }: Props) => {
    const { t } = useTranslation()

    return (
      <Dialog
        selectorState={true}
        compact
        showCloseButton={true}
        closeButtonInline
        lockScroll={scrollLock}
        closeAction={onClose}
        title={title ?? t('spot_detail.quiz.title', 'クイズ')}
      >
        <div data-testid="dialog-quiz-challenge">
          {image && (
            <div className="mb-[15px] overflow-hidden">
              <img src={image} alt="" className="w-full h-[168px] object-cover" />
            </div>
          )}

          <HtmlContent html={question} variant="subtitle1" className="mb-[15px] font-bold text-black" />

          <ul className="flex flex-col gap-[10px]">
            {choices.map((choice) => (
              <li key={choice.id}>
                <button
                  type="button"
                  onClick={() => onSelect(choice.id)}
                  disabled={isLoading}
                  className="w-full h-[36px] bg-white border border-[#757575] rounded-[8px] text-[#757575] text-[13px] font-bold disabled:opacity-50"
                >
                  {choice.item ?? ''}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </Dialog>
    )
  },
)
